module.exports = __webpack_public_path__ + "img/slide-4-ua.5027faad.png";